export default function convertToTitleCase(inputText) {
  // Split the input text at underscores and capitalize each word
  const words = inputText?.split('_')?.map(word => {
    return word?.charAt(0)?.toUpperCase() + word?.slice(1);
  });

  // Join the words with a space and return the result
  return words?.join(' ');
}